import { IonButton, IonIcon, IonRouterLink, IonText } from '@ionic/react';
import React from 'react';

import ButtonContainer from '@/components/common/buttonContainer/ButtonContainer';
import Spacer from '@/components/common/spacer/Spacer';
import RequestSummary from '@/components/summary/requestSummary/RequestSummary';
import { useScheduleFlow } from '@/contexts/ScheduleFlowContext';
import { ROUTES } from '@/utils/routes';
import { arrowForwardCircleOutline } from 'ionicons/icons';

import './Confirmation.css';

const Confirmation: React.FC = () => {
  const {
    clinic,
    selectedDentist: dentist,
    patient,
    request,
    durationInMinutes,
    confirmRequest: onConfirm,
    reset: onReset
  } = useScheduleFlow();

  const copy = {
    subHeader: 'REVIEW AND SUBMIT YOUR REQUEST',
    header: (
      <>
        Confirm your <IonText color="primary">appointment</IonText> details
      </>
    ),
    message: (
      <>
        Review the details below and click <i>Request Appointment</i> to
        proceed.
      </>
    ),
    buttonText: 'Request Appointment'
  };

  return (
    <div id="confirmation">
      <Spacer top={32} bottom={24}>
        <h4 id="subHeader">{copy.subHeader}</h4>
        <h1 id="header">{copy.header}</h1>
        <p id="message">{copy.message}</p>
      </Spacer>
      <RequestSummary
        clinic={clinic}
        dentist={dentist}
        patient={patient}
        request={request}
        showStatus={false}
        durationInMinutes={durationInMinutes}
      />
      <Spacer top={16} bottom={172}>
        <div id="startOver">
          <p>Is there something wrong?</p>
          <IonRouterLink onClick={onReset}>Start Over</IonRouterLink>
        </div>
      </Spacer>
      <ButtonContainer transparent={false}>
        <IonButton
          id="nextButton"
          onClick={onConfirm}
          expand="block"
          fill="solid"
          size="default"
          color="primary"
          strong={true}
        >
          <IonIcon slot="start" icon={arrowForwardCircleOutline}></IonIcon>
          {copy.buttonText}
        </IonButton>
        <p id="confirmationNote">
          By clicking Request Appointment, you agree to our{' '}
          <IonRouterLink routerLink={ROUTES.TERMS_OF_SERVICE} target="_blank">
            Terms of Service
          </IonRouterLink>{' '}
          and{' '}
          <IonRouterLink routerLink={ROUTES.PRIVACY_POLICY} target="_blank">
            Privacy Policy
          </IonRouterLink>
          .
        </p>
      </ButtonContainer>
    </div>
  );
};

export default Confirmation;
